/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect} from "react";
import {Link} from "react-router-dom";
import Loader from "../Common/Loader";
import CardContext from "../../Context/CardContext";
import Pagination from "../Common/Pagination";
import StudentCardSearchForm from "../Common/StudentCard/StudentCardSearchForm";
import RenewalPayment from "./RenewalPayment";
import useStateCallback from "../../util/customHooks/useStateCallback";
import AttachRenewalCard from "./AttachRenewalCard";

function LostCards(props) {
  const {lostPage, page, assignedPage, unassignedPage, lostMeta, setLostPage, lostFirst, lostQuery, setLostQuery, loading, loading2, lostCardList, getLostCards,
    searchLostCard, getCards, getUnassignedCards, getAssignedCards, countAssignedCards, countAssignedWristbands} = useContext(CardContext);
  const [modal, setModal] = useStateCallback(false);
  
  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= lostMeta.length) {
      setLostPage(newPage);
    }
  };

    const setCards = (e) => {
      e.preventDefault();
      setLostQuery("");
      setLostPage(1);
      getLostCards(1);
    };
  
    useEffect(() => {
      if (lostQuery) {
        searchLostCard();
      } else {
        getLostCards(lostPage);
      }
    }, [lostPage]);

    const renewCardPayment=(e,item)=>{
      setModal(false, ()=>setModal(<RenewalPayment userID={item.student.user_id} isOpen={true}/>))
    }

    const assignNewCard=(e,item)=>{
      setModal(false, ()=>setModal(<AttachRenewalCard studentID={item.student.student_id} fullName={item.student.full_name} countAssignedCards={countAssignedCards} countAssignedWristbands={countAssignedWristbands} page={page} assignedPage={assignedPage} unassignedPage={unassignedPage} getAssignedCards={getAssignedCards} getAllCards={getCards} getUnassignedCards={getUnassignedCards} isOpen={true}/>))
    }

 
    return (
        <>
        {modal}
        <StudentCardSearchForm searchTerm={lostQuery} setSearchTerm={setLostQuery} searchCards={searchLostCard} setCards={setCards} setPage={setLostPage} placeholder="Enter card / wristband number..."/>
        <div className="table-responsive">
{loading || loading2 ? (
<Loader /> 
) : (
<table className="table display data-table text-nowrap">
<thead>
<tr>
<th scope="col" className="wd-10p">No.</th>
<th>Serial Number</th>
<th>Type</th>
<th>Student Name</th>
<th>Done By</th>
<th>Status</th>
<th>Actions</th>

</tr>
</thead>
<tbody>
{lostCardList.length > 0 ? (
lostCardList.map((item, index) => (
  <tr key={index}>
    <th scope='row' style={{width:"5px"}}>{index + lostFirst + 1}</th>
    <td>{item.card_number}</td>
    <td>{item.type==="CARD"?<span class="badge badge-info">{item.type}</span>:<span class="badge badge-wb">{item.type}</span>}</td>
          <td>{item.student.full_name}</td>
            <td>{item.marked_by}</td>
          <td><span class="badge badge-danger">Inactive</span></td>
          <td>
              <div className="dropdown">
                <Link
                  to="#"
                  className="dropdown-toggle"
                  data-toggle="dropdown"
                  aria-expanded="false">
                  <span className="flaticon-more-button-of-three-dots"></span>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                
                <Link
                  className="dropdown-item"
                  to="#"
                  onClick={(e) => renewCardPayment(e,item)}
                  >
                  <i className="fa fa-money-check-dollar mr-1" style={{color:"green"}}></i>
                  Pay For Renewal
                </Link>
                  <Link
                  className="dropdown-item"
                  to="#"
                  onClick={(e) => assignNewCard(e,item)}
                  >
                  <i className="fa fa-square-plus mr-1"></i>
                  Assign Replacement
                </Link>
                </div>
              </div>
          </td>
  </tr>
))
) : (
<tr>
  <td colSpan="5" style={{ textAlign: "center" }}>
    No cards reported as lost yet.
  </td>
</tr>
)}
</tbody>
</table>
)}
        </div>
        <Pagination currentPage={lostPage} totalPages={lostMeta.length} onPageChange={handlePagination}/>

         </>
  );
}

export default LostCards;
